import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../styles/landing.css'

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const navigate = useNavigate()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header>
      <div style={{ width: '100%', padding: '0 var(--spacing-md)' }}>
        <div className="flex flex-between" style={{ padding: 'var(--spacing-md) 0', alignItems: 'center' }}>
          {/* Logo */}
          <div
            className="flex flex-center"
            style={{ alignItems: 'center', cursor: 'pointer' }}
            onClick={() => navigate('/')}
            role="button"
            tabIndex={0}
            aria-label="Ir al inicio"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate('/');
              }
            }}
          >
            <img
              src="/icons/logo.png"
              alt="AscensosApp Vortex"
              style={{
                height: '40px',
                filter: 'brightness(1) invert(0)'
              }}
            />
            <span style={{
              marginLeft: 'var(--spacing-md)',
              fontSize: '1.25rem',
              fontWeight: '700',
              color: 'var(--text-primary)'
            }}>
              Ascensos App
            </span>
          </div>

          {/* Desktop Navigation */}
            <nav className="desktop-nav" aria-label="Navegación principal" style={{ flex: 1, justifyContent: 'space-between', marginLeft: 'var(--spacing-lg)' }}>
            <button
              onClick={() => navigate('/cursos')}
              className="btn-cursos"
              style={{
                padding: '8px 16px',
                fontSize: '0.9rem',
                background: 'rgba(197, 160, 89, 0.15)',
                border: '1px solid rgba(197, 160, 89, 0.4)',
                borderRadius: '50px',
                color: 'var(--gold-light)',
                fontWeight: '500',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.4rem',
                transition: 'background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.2s ease'
              }}
            >
              <span>🎓</span>
              <span>Cursos Vortex</span>
            </button>
            <a href="#about" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Sobre nosotros</a>
            <a href="#features" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Características</a>
            <a href="#howitworks" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Cómo funciona</a>
            <a href="#testimonials" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Testimonios</a>
            <a href="#screenshots" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Galería</a>
            <a href="#availability" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Descarga</a>
            <a href="#contact" style={{ color: 'var(--text-secondary)', fontWeight: '500', fontSize: '0.9rem', textDecoration: 'none' }}>Contacto</a>
            <button
              onClick={() => navigate('/purchase-license')}
              className="btn-primary"
              style={{ padding: '10px 25px', fontSize: '0.9rem', fontFamily: 'inherit', fontWeight: 500, textTransform: 'none', letterSpacing: 'normal', display: 'flex', alignItems: 'center', gap: '0.5rem', minHeight: '40px' }}
            >
              <span>💎</span>
              <span>Adquirir Suscripción</span>
            </button>
            <button
              onClick={() => navigate('/login')}
              className="btn-primary"
              style={{ padding: '8px 25px', fontSize: '0.9rem', fontFamily: 'inherit', fontWeight: 500, textTransform: 'none', letterSpacing: 'normal' }}
            >
              Iniciar sesión
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            type="button"
            onClick={toggleMenu}
            className="mobile-menu-btn"
            aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-nav"
            aria-haspopup="true"
          >
            <span aria-hidden="true">{isMenuOpen ? '✕' : '☰'}</span>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav id="mobile-nav" className="mobile-nav" aria-label="Navegación móvil">
            <button
              onClick={() => { navigate('/cursos'); setIsMenuOpen(false); }}
              style={{
                margin: 'var(--spacing-sm) 0',
                background: 'rgba(197, 160, 89, 0.2)',
                border: '1px solid rgba(197, 160, 89, 0.4)',
                padding: '10px 20px',
                borderRadius: '50px',
                color: 'var(--gold-light)',
                fontWeight: '600',
                fontSize: '0.9rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              <span>🎓</span>
              <span>Cursos Vortex</span>
            </button>
            <a href="#about" onClick={() => setIsMenuOpen(false)}>¿Qué es Vortex?</a>
            <a href="#instituciones" onClick={() => setIsMenuOpen(false)}>Instituciones</a>
            <a href="#features" onClick={() => setIsMenuOpen(false)}>Características</a>
            <a href="#howitworks" onClick={() => setIsMenuOpen(false)}>Cómo funciona</a>
            <a href="#testimonials" onClick={() => setIsMenuOpen(false)}>Testimonios</a>
            <a href="#screenshots" onClick={() => setIsMenuOpen(false)}>Galería</a>
            <a href="#availability" onClick={() => setIsMenuOpen(false)}>Descarga</a>
            <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contacto</a>
            <button
              onClick={() => { navigate('/purchase-license'); setIsMenuOpen(false); }}
              className="btn-primary"
              style={{ margin: 'var(--spacing-sm) 0', fontSize: '0.9rem', fontFamily: 'inherit', fontWeight: 500, textTransform: 'none', letterSpacing: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
            >
              <span>💎</span>
              <span>Adquirir Suscripción</span>
            </button>
            <button
              onClick={() => { navigate('/login'); setIsMenuOpen(false); }}
              className="btn-primary"
              style={{ margin: 'var(--spacing-sm) 0', fontSize: '0.9rem', fontFamily: 'inherit', fontWeight: 500, textTransform: 'none', letterSpacing: 'normal' }}
            >
              Iniciar sesión
            </button>
          </nav>
        )}
      </div>
    </header>
  )
}
